var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 81C47.3825 81 42 75.6175 42 69C42 62.3825 47.3825 57 54 57C60.6175 57 66 62.3825 66 69C66 75.6175 60.6175 81 54 81ZM54 63C50.6925 63 48 65.6925 48 69C48 72.3075 50.6925 75 54 75C57.3075 75 60 72.3075 60 69C60 65.6925 57.3075 63 54 63Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 66.2625C28.0375 66.2625 24 62.225 24 57.2625C24 52.3 28.0375 48.2625 33 48.2625C37.9625 48.2625 42 52.3 42 57.2625C42 62.225 37.9625 66.2625 33 66.2625ZM33 54.2625C31.345 54.2625 30 55.6075 30 57.2625C30 58.9175 31.345 60.2625 33 60.2625C34.655 60.2625 36 58.9175 36 57.2625C36 55.6075 34.655 54.2625 33 54.2625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 84C71.6925 84 69 81.3075 69 78C69 74.6925 71.6925 72 75 72C78.3075 72 81 74.6925 81 78C81 81.3075 78.3075 84 75 84Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.28 98.9125L17.28 78.14L15 75.2275V41.865L15.6575 39.9925C23.7075 29.9275 34.9875 23.665 48.2825 21.8775C58.26 20.5375 65.8325 22.17 66.1475 22.24L67.6575 23.0875L104.158 60.9175L104.997 63V72.15L101.4 75.09C101.105 75.03 100.8 75 100.497 75C98.0175 75 95.9975 77.0175 95.9975 79.5C95.9975 81.9825 98.0175 84 100.497 84C100.802 84 101.105 83.97 101.4 83.91L104.997 86.85V96L101.277 98.9125H101.28ZM21 72.88L99 92.17V89.895C93.9175 89.165 90 84.7825 90 79.5025C90 74.2225 93.9175 69.84 99 69.11V64.215L64.01 27.95C61.8975 27.605 56.0275 26.865 48.8725 27.8575C37.425 29.4425 28.05 34.5175 21 42.94V72.8825V72.88Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7309 38.9545L17.2672 44.7732L101.268 65.9039L102.731 60.0852L18.7309 38.9545Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheese);
export default __webpack_public_path__ + "static/media/Cheese.48f5274e.svg";
export { ForwardRef as ReactComponent };